export default "__VITE_ASSET__6_UqStTM__"